const config = {
  serverUri: import.meta.env.VITE_API_URL,
  myURI: import.meta.env.VITE_MY_DOMAINE,
  apiSymphonyDigidom: import.meta.env.VITE_API_DIGIDOM,
  segmentWriteKey: import.meta.env.VITE_SEGEMENT_WRITE_KEY,
  urlTrackingLetter: import.meta.env.VITE_TRACKING_LETTER,
  digidomSite: import.meta.env.VITE_DIGIDOM_SITE,
  apiBaseURL: import.meta.env.VITE_BASE_URL_API,
  adminUrl: import.meta.env.VITE_NEW_ADMIN_URL,
  crispWebSiteId: import.meta.env.VITE_CRISP_WEBSITE_ID,
  sentryDNS: import.meta.env.VITE_SENTRY_DNS,
  nodeENV: import.meta.env.VITE_ENV,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  corsDigidom: `${import.meta.env.VITE_API_BASE_URL}/proxy`,
  invoiceLink: import.meta.env.VITE_INVOICE_LINK,
  googleTagManager: import.meta.env.VITE_GTM,
  tunnelUrl: import.meta.env.VITE_TUNNEL_URL,
  legalNoticeUrl: import.meta.env.VITE_LEGAL_NOTICE_URL,
  customerIoSiteId: import.meta.env.VITE_CUSTOMER_IO_SITE_ID,
  customerIoApiKey: import.meta.env.VITE_CUSTOMER_IO_API_KEY,
  customerIoRegion: import.meta.env.VITE_CUSTOMER_IO_REGION,
  customerIoCdnUrl: import.meta.env.VITE_CUSTOMER_IO_CDN_URL,
  customerIoInAppEnabled: import.meta.env.VITE_CUSTOMER_IO_IN_APP_ENABLED !== 'false',
  customerIoInboxEnabled:
    import.meta.env.VITE_CUSTOMER_IO_INBOX_ENABLED !== undefined
      ? import.meta.env.VITE_CUSTOMER_IO_INBOX_ENABLED === 'true'
      : import.meta.env.VITE_ENV === 'local',
  customerIoInboxFloatingButtonEnabled:
    import.meta.env.VITE_CUSTOMER_IO_INBOX_FLOATING_BUTTON !== undefined
      ? import.meta.env.VITE_CUSTOMER_IO_INBOX_FLOATING_BUTTON === 'true'
      : import.meta.env.VITE_ENV === 'local',
};

export default config;
